import { render, staticRenderFns } from "./Global.vue?vue&type=template&id=e1f0b736&scoped=true&lang=pug"
import script from "./Global.vue?vue&type=script&lang=js"
export * from "./Global.vue?vue&type=script&lang=js"
import style0 from "./Global.vue?vue&type=style&index=0&id=e1f0b736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f0b736",
  null
  
)

export default component.exports